import type { SerializedMeterAddon } from '@enmon/commons/lib/tools';
import { Space, type TableColumnsType } from 'antd';
import { EmptyCell, Tag } from 'components';
import { Link } from 'react-router-dom';
import type { Key } from 'react';
import type { SortOrder } from 'antd/es/table/interface';
import { MeterModelTableActions } from '../components/TableActions';

export const getMeterModuleTableColumnsConfig = ({
  isMagicRole,
  sortState,
}: {
  isMagicRole: boolean;
  sortState: { field: Key | null; order: SortOrder };
}): TableColumnsType<SerializedMeterAddon> => [
  {
    key: 'name',
    title: 'Module',
    width: 200,
    sorter: true,
    sortOrder: sortState.field === 'name' ? sortState.order : null,
    render: (_, record) => (
      <Link replace to={{ pathname: `/reseller-data/model-library/module/${record.id}` }}>
        {record.name}
      </Link>
    ),
  },
  {
    key: 'technology',
    title: 'Technology',
    width: 150,
    render: (_, record) =>
      record.technology ? (
        <Space wrap size={[8, 0]}>
          <Tag key={`${record.id}-${record.technology}`}>{record.technology}</Tag>
        </Space>
      ) : (
        <EmptyCell />
      ),
  },
  ...(isMagicRole
    ? ([
        {
          key: 'action',
          width: 130,
          title: 'Actions',
          fixed: 'right',
          render: (_, record) => <MeterModelTableActions module={record} />,
        },
      ] satisfies TableColumnsType<SerializedMeterAddon>)
    : []),
];
